import { useEffect } from 'react';
import api from '../lib/api';

// Applies dynamic site branding: <title>, meta description, favicon.
// Also exposes site_name & logo_url via a global window.__vaSettings for the Header.
// Seeds a synchronous default so the first paint never shows the wrong brand.
if (typeof window !== 'undefined' && !window.__vaSettings) {
  window.__vaSettings = { site_name: 'NUBES MTY' };
}

const SiteHead = () => {
  useEffect(() => {
    let alive = true;

    // Helper to update or create a meta tag by attribute/name.
    const setMeta = (attr, name, content) => {
      if (!content) return;
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    api.get('/settings').then((r) => {
      if (!alive) return;
      const s = r.data || {};
      window.__vaSettings = s;
      const title = s.meta_title || s.site_name || 'NubesMTY';
      const description = s.meta_description || 'NubesMTY · Vape shop premium en Monterrey. Envío discreto, marcas 100% originales.';
      // <title>
      document.title = title;
      // meta description
      setMeta('name', 'description', description);
      // Open Graph mirror (so admin edits reflect in shared previews)
      setMeta('property', 'og:title', title);
      setMeta('property', 'og:description', description);
      setMeta('property', 'og:site_name', s.site_name || 'NubesMTY');
      setMeta('name', 'twitter:title', title);
      setMeta('name', 'twitter:description', description);
      // favicon
      if (s.favicon_url) {
        let link = document.querySelector('link[rel="icon"]');
        if (!link) {
          link = document.createElement('link');
          link.rel = 'icon';
          document.head.appendChild(link);
        }
        link.href = s.favicon_url;
      }
      // Notify Header (in case it mounts after this)
      window.dispatchEvent(new CustomEvent('va-settings-updated', { detail: s }));
    }).catch(() => {});
    return () => { alive = false; };
  }, []);
  return null;
};

export default SiteHead;
